import React from 'react';

export default function Profile({userData}) {
   return (
      <div className="dropdown d-flex">
         <div className=' bg-light mx-2' style={{ borderRadius: "50px", height: '37px', width: '40px' }}>
            <img src={userData.imgUrl} className=" ms-auto me-auto d-block" alt='' width={40} height={37} style={{borderRadius: "50px",}}/>
         </div>
         <button className="btn navbar-top dropdown-toggle mt-0 p-0 " type="button" data-bs-toggle="dropdown" aria-expanded="false">
            {userData.name}
         </button>
         <ul className="dropdown-menu">
            <li>  <a href='/userProfile' className='dropdown-item'>
               Profile
            </a></li>
            <li><a className="dropdown-item" href="/logout">Log Out</a></li>
         </ul>
      </div>
   );
}
